import {LinkFactory, Routes, Paths as PathsCtor} from '@mintdata-wsp/wsp/ui/routes/RouteConfig';

export class RoutingSingleton
{
    private  _paths:PathsCtor       = new PathsCtor();
    private  _routes:Routes         = new Routes();
    private  _links:LinkFactory     = new LinkFactory();

    public paths():PathsCtor    { return this._paths; }
    public routes():Routes      { return this._routes; }
    public links():LinkFactory  { return this._links; }
}

export const Routing = new RoutingSingleton();

export const links = Routing.links();
export const paths = Routing.paths();


